import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { apiRequest } from './../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { BUD_BASIC_02_Schema } from './BUD_BASIC_02_Schema';
import { useSelector } from 'react-redux';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';

/**
 * 예산관리 기본02(BUD_BASIC_02) 관련 React Query 훅 모음
 * - 기본 조회(useQuery): useSearch2
 * - 저장(useMutation 기반): useSave2
 *
 * 만약 MUTATION 훅에서 공통 응답 처리 외에 추가 성공 콜백이 필요하면
 * successOptions 파라미터로 onSuccess 콜백 함수를 넘겨줄 수 있다.
 */
export const useSearch1 = (options = {}) => {
  const searchInfo = useSelector((state) => state.SearchInfo);
  const { onSuccess } = options;
  const params = mapParamsBySchema(BUD_BASIC_02_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['budgetManagement', 'getBudBasicR2', params],
    queryFn: () =>
      apiRequest('post', Global.urls.BudgetManagement.getBudBasicR2, params),
    enabled: searchInfo.custCd ? true : false,
  });

  useEffect(() => {
    if (!query.isSuccess) return;
    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

// 구분상세 삭제
export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, BUD_BASIC_02_Schema.mapper.delete1);

    return apiRequest(
      'post1',
      Global.urls.BudgetManagement.deleteBudItemD1,
      payload
    );
  }, options);
};

export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, BUD_BASIC_02_Schema.mapper.save1);

    return apiRequest(
      'post1',
      Global.urls.BudgetManagement.saveBudBasicU1,
      payload
    );
  }, options);
};
